import React, {useEffect, useState} from 'react';
import Button from '@react/react-spectrum/Button';
import ModalContainer from '@react/react-spectrum/ModalContainer';
import Dialog from '@react/react-spectrum/Dialog';
import Linkout from '@react/react-spectrum/Icon/LinkOut';
import Close from '@react/react-spectrum/Icon/Close';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import {Utils} from '../../../utils/Globals';
import {getLocalizedURL, getAppLocale} from '@intl/adobe-locales';
import './ccxInterstitial.scss';

type Props = {
	onClose: Function;
};

export function InterstitialDialog(props: Props) {
	const sendAnalytic = (workflow, eventType, eventSubType) => {
		const analytics = new AnalyticsUtil(true);
		analytics.ingest.initializeDefaultData();
		const data: dataObject = {
			setEventWorkFlow: workflow,
			setEventType: eventType,
			setEventSubtype: eventSubType,
		};
		analytics.logAnalytics(data);
		return analytics.ingest.sendToIngest();
	};

	useEffect(() => {
		sendAnalytic('CCX Templates interstitial', 'render', null);
	}, []);

	return (
		<Dialog
			autoFocusButton={null}
			backdropClickable={false}
			confirmDisabled={false}
			disableEscKey
			isDismissible={false}
			keyboardConfirm={false}
			id='interstitial-dialog'
			className='interstitial-dialog'
		>
			<div className='interstitialDialogWrapper'>
				<img src='/assets/common/CCXInterstitialMainImg.jpg' className='interstitialMainImage' />
				<div className='interstitialDesc'>
					<h2 className='interstitialHeading'>{Utils.localizedStrings['ccx.interstitial.heading']}</h2>
					<div style={{display: 'flex', paddingBottom: '24px', flex: '1 0 auto'}}>
						<img src='/assets/common/CCXInterstitialLogo.png' className='interstitialLogo' />
						<h2>{Utils.localizedStrings['ccx.interstitial.title']}</h2>
					</div>
					<p>{Utils.localizedStrings['ccx.interstitial.mainContent']}</p>
					<p>{Utils.localizedStrings['ccx.interstitial.subContent']}</p>
				</div>
			</div>
			<div className='interstitialButtons'>
				<Button
					variant='cta'
					onClick={() => {
						sendAnalytic('CCX Templates interstitial', 'click', null);
						window.open(
							`${window.CONFIG.CCX_BROWSE_TEMPLATE 
							}&locale=${ 
								getAppLocale('spark', window.cchome.util.getStartupLanguage(), 'en')}`,
						);
						props.onClose();
					}}
					icon={<Linkout />}
					label={Utils.localizedStrings['ccx.interstitial.cta']}
				/>
			</div>
			<Button
				variant='tool'
				icon={<Close />}
				aria-label='Close'
				onClick={() => {
					sendAnalytic('CCX Templates interstitial', 'click', 'dismiss');
					props.onClose();
				}}
				id='quick-task-close-button'
			/>
		</Dialog>
	);
}

export default function showInterstitial() {
	const key = ModalContainer.show(
		<InterstitialDialog
			onClose={() => {
				ModalContainer.hide(key);
			}}
		/>,
	);
}
